import * as UNIT_TYPES from 'store/units/types';
import * as CONNECTION_TYPES from 'store/connections/types';
import {
  deleteGroups,
  deleteGroupsWithHistory,
  editGroup,
  editGroupWithHistory,
  setSelectableCrusherRiskFactorIncluded,
  setUnitValue,
  setChamberAnalysisDisplaySettings,
  updatePanelsWithHistory,
} from 'store/units/reducer';
import { REDO, UNDO } from 'store/createHistoryReducer';
import { setCurrentFile, setCurrentFileName } from 'store/storageunits/reducer';
import {
  setSettings,
  editDisplayPlantSettings,
  editDisplayUnitSettings,
  editPrintProperties,
  setDisplayDrawingSheet,
  setAutoSimulate,
} from 'store/settings/reducer';
import {
  setProjectData,
  setRiskAssessmentSimulationSettings,
  setCustomConnectionColor,
} from 'store/documentMetadata/reducer';

/* Action types that should set fileHasBeenEdited to true */
export const FILE_CHANGE_ACTIONS = [
  setSettings.type,
  setProjectData.type,
  setRiskAssessmentSimulationSettings.type,
  setCustomConnectionColor.type,
  editDisplayPlantSettings.type,
  editDisplayUnitSettings.type,
  editPrintProperties.type,
  setDisplayDrawingSheet.type,
  setAutoSimulate.type,
  setUnitValue.type,
  setChamberAnalysisDisplaySettings.type,
  UNIT_TYPES.ADD_UNIT,
  UNIT_TYPES.ADD_STORAGE_TO_SCREEN_OUTPUTS,
  UNIT_TYPES.REMOVE_UNIT,
  UNIT_TYPES.EDIT_UNIT_INFO,
  UNIT_TYPES.EDIT_FLOW_PROPERTIES,
  UNIT_TYPES.EDIT_LAYOUT,
  UNIT_TYPES.EDIT_LAYOUTS,
  UNIT_TYPES.EDIT_MULTIPLE_UNIT_LOCATIONS,
  UNIT_TYPES.EDIT_PORT,
  UNIT_TYPES.INSERT_ON_CONNECTION,
  UNIT_TYPES.TOGGLE_MIRRORING,
  UNIT_TYPES.REPLACE_UNIT,
  updatePanelsWithHistory.type,
  CONNECTION_TYPES.ADD_CONNECTION,
  CONNECTION_TYPES.REMOVE_CONNECTION,
  CONNECTION_TYPES.EDIT_CONNECTION,
  CONNECTION_TYPES.UPDATE_CONNECTION_POINTS,
  CONNECTION_TYPES.SET_CONNECTION_COLOR,
  UNDO,
  REDO,
  setCurrentFile.type,
  setCurrentFileName.type,
  editGroup.type,
  editGroupWithHistory.type,
  deleteGroups.type,
  deleteGroupsWithHistory.type,
  UNIT_TYPES.EDIT_UNIT_FLOW,
  setSelectableCrusherRiskFactorIncluded.type,
];
